import {Button} from '@mui/material';
import {EmptySearchState} from 'presentation/components';
import {ChatRoomsEnum} from 'presentation/constants';
import {HandleMessage} from 'presentation/components/HandleMessage';
import {useCallChatRoom} from 'presentation/pages/private/hooks';
import {translations} from 'presentation/translations-new';
import React from 'react';
import {SpecialtyNotFoundProps} from './types';
import {Loading} from 'presentation/components/Loading/Loading';

const {specialtyNotFound} = translations['pt-br'].privateFlow.bookingFlow;

const OdontoSpecialtyNotFound = ({handleAction}: SpecialtyNotFoundProps) => {
	const {callChatRoom, IS_LOADING: callChatRoomIsLoading} = useCallChatRoom();
	const handleCallChatRoom = () => {
		callChatRoom(ChatRoomsEnum.ODONTO);
	};

	return (
		<EmptySearchState
			title=""
			customTitle={
				<HandleMessage message={specialtyNotFound.title} variables={['especialidades']} />
			}
			description={specialtyNotFound.description}>
			<Button onClick={handleAction} size="large">
				{specialtyNotFound.primaryButton}
			</Button>
			<Button
				onClick={handleCallChatRoom}
				variant="outlined"
				size="large"
				disabled={callChatRoomIsLoading}
				endIcon={callChatRoomIsLoading ? <Loading size={16} color="inherit" /> : null}>
				{specialtyNotFound.secondaryButton}
			</Button>
		</EmptySearchState>
	);
};

export {OdontoSpecialtyNotFound};
